import { createContext, useContext, type ReactNode } from 'react';

export interface AuthContextValue {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
}

const AuthContext = createContext<AuthContextValue>({});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}

interface AuthProviderProps {
  getAccessToken?: () => Promise<string | null>;
  instanceId?: string;
  children: ReactNode;
}

export function AuthProvider({ getAccessToken, instanceId, children }: AuthProviderProps): React.ReactElement {
  return (
    <AuthContext.Provider value={{ getAccessToken, instanceId }}>
      {children}
    </AuthContext.Provider>
  );
}
